export function phoneFormatter(phoneNumber) {
  const phoneFieldValue = phoneNumber.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  return (
    !phoneFieldValue[2] ? phoneFieldValue[1] : '(' + phoneFieldValue[1] + ') ' + phoneFieldValue[2] + (phoneFieldValue[3] ? '-' + phoneFieldValue[3] : '')
  );
}